export const ContainerType = Object.freeze({
    WIDGETLIST: "WIDGETGRID",
    INFOBARWIDGETLIST: "INFOBARWIDGETLIST",
    BOX: "BOX",
    TAB: "TAB",
    COLUMN: "COLUMN",
    ROW: "ROW",
    ACCORDION: "ACCORDION",
    PAGE: "PAGE",
})

export const WidgetType = Object.freeze({
    TEXT: "TEXT",
    NUMBER: "NUMBER",
    CURRENCY: "CURRENCY",
    LONGTEXT: "LONGTEXT",
    SELECT: "SELECT",
    LABEL: "LABEL",
    VALUE: "VALUE",
    LINKVALUE: "LINKVALUE",
    DATE: "DATE",
    EMPTY: "EMPTY",
    BUTTON: "BUTTON",
    TABLE: "TABLE",
    SWITCH: "SWITCH",
    MULTISELECT: "MULTISELECT",
    SEARCHINPUT: "SEARCHINPUT",
    EDITOR: "EDITOR",
    TABLEHEADER: "TABLEHEADER",
    RADIOBUTTON: "RADIOBUTTON",
    LABELEDVALUE: "LABELEDVALUE",
    CHECKBOX: "CHECKBOX",
})

export const IconTypes = Object.freeze({
    INSERTDRIVEFILEICON: "InsertDriveFileIcon",
    CONTENTCOPYICON: "ContentCopyIcon",
    KEYBOARDDOUBLEARROWLEFTICON: "KeyboardDoubleArrowLeftIcon",
    SAVEICON: "SaveIcon",
    KEYBOARDDOUBLEARROWRIGHTICON: "KeyboardDoubleArrowRightIcon",
    SAVEALTICON: "SaveAltIcon",
    PLUS: "Plus"
})

export const DisableTypes = Object.freeze({
    STATUSBEGRUENDUNG: "STATUSBEGRUENDUNG",
    DEFAULT: "DEFAULT",
    PERMANENT: "PERMANENT",
})